import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-gantt-grid',
  templateUrl: './gantt-grid.component.html',
  styleUrls: ['./gantt-grid.component.scss']
})
export class GanttGridComponent implements OnInit {

  @ViewChild('header', { static: true }) headerRef: ElementRef;
  @Input() data;
  @Input() dateType;
  @Input() headers;
  JSON;
  now;

  constructor(private el: ElementRef) {
    this.JSON = JSON;
  }

  ngOnInit() {
    this.now = moment().valueOf() + (moment().utcOffset() * 60000);
  }

  public getTodayLineHeight() {
    return this.el.nativeElement.clientHeight;
  }

  public getTodayLineLeft() {
    const totalTime = this.headers[this.headers.length - 1] - this.headers[0] + this.headers[1] - this.headers[0];
    const totalPx = this.headerRef.nativeElement.scrollWidth - 150;
    const stripTime = this.now - this.headers[0];
    return stripTime * totalPx / totalTime;
  }

  public getGridWidth() {
    if (this.headerRef && this.headers) {
      return (this.headerRef.nativeElement.scrollWidth - 150) / this.headers.length;
    }
  }

  public getStripWidth(strip) {
    if (this.headerRef && this.headers) {
      const headerMillisWidth = this.headers[this.headers.length - 1] + this.headers[1] - this.headers[0] - this.headers[0];
      const headerWidth = this.headerRef.nativeElement.scrollWidth - 150;
      const stripMillisWidth = strip.to - strip.from;
      const stripWidth = headerWidth * stripMillisWidth / headerMillisWidth;
      return stripWidth;
    }
  }

  public getStripLeftPadding(strip) {
    if (this.headerRef && this.headers) {
      const headerMillisWidth = this.headers[this.headers.length - 1] + this.headers[1] - this.headers[0] - this.headers[0];
      const headerWidth = this.headerRef.nativeElement.scrollWidth - 150;
      const stripMillisLeft = strip.from - this.headers[0];
      const stripLeft = headerWidth * stripMillisLeft / headerMillisWidth;
      return stripLeft;
    }
  }

  public getColor(active, index1, index2) {
    if (this.data) {
      if (active) {
        let accumulateIndex = 0;
        if (index2 !== 0) {
          let accumulate = 0;
          for (let i = 0; i < this.data.length; i++) {
            if (i === (index1)) {
              break;
            }
            accumulate += this.data[i].content.length;
          }
          accumulateIndex = (accumulate + index2 + 1) % 10;
        } else {
          accumulateIndex = index1 % 10;
        }
        switch (accumulateIndex) {
          case 0:
            return 'red';
          case 1:
            return 'yellow';
          case 2:
            return 'cyan';
          case 3:
            return 'orange';
          case 4:
            return 'green';
          case 5:
            return 'blue';
          case 6:
            return 'purple';
          case 7:
            return 'pink';
          case 8:
            return 'darkblue';
          case 9:
            return 'brown';
        }
      } else {
        return 'disabled';
      }
    }
  }

  public getStringFromArray(array, attr) {
    if (array && (array.length > 0) && attr) {
      let str = '';
      array.forEach((i, n) => {
        str += i[attr];
        str += ((array.length - 1 === n)  ? '' : ', ');
      });
      return str;
    }
    return null;
  }
}
